<div style="font-size: 12px">
  <h1 mat-dialog-title class="text-center"><div translate>PROJECT.DIALOG.WELCOME_MESSAGE_TITLE</div></h1>
  <p mat-dialog-body>
      {{ 'PROJECT.DIALOG.WELCOME_MESSAGE' | translate }}
  </p>
  <p mat-dialog-body>
      {{ 'PROJECT.DIALOG.WELCOME_MESSAGE2' | translate }}
  </p>
  <div class="mt-2">
    <mat-checkbox class="float-left" style="font-size:9px;" [(ngModel)]="showProjectTips">  {{ 'PROJECT.DIALOG.DONT_SHOW' | translate }} </mat-checkbox>
    <button class="float-right fdm-button" color="primary" mat-flat-button (click)="onClick()">{{ 'GENERIC.OK' | translate }}</button>
  </div>
</div>
